import React from 'react'
import { Button, Table, Collapse, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { DescriptionTooltipView } from '../../_reusedcomponents/DescriptionTooltipView'
import { enumvaluetranslations } from '../../../utils/enumvaluetranslations'
import { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal } from '../../../utils/tableparser'
import { parseFloatCurrency } from '../../../utils/formatting/floatnumberparsing'
import { getColourClassStatus, correctionColor } from '../../../utils/cssgetter'
import { RenderImage } from '../../images/ImageView'
import { MainComponentHeaderView } from '../../_reusedcomponents/MainComponentHeaderView'
import { getCsvDataForAllTransactions, getCsvDataForSingleTransaction, getCsvFileName } from '../../../utils/csvdatagetter'
import { ExportCSV } from '../../_reusedcomponents/ExportCSVView'


/**
 * View for Header of OutgoingTransactions. Uses Composition with TransactionHeaderView.
 * The Button opens a new empty mask to enter transaction
 * @param {any} handleShowMaskDelivery handles visibility of transaction mask
 * @param {any} handleSearchInput sets a new string value if input changes
 * @param {any} setFilterbar passed hook for setting the table-internal filter nemu on or off
 * @param {any} filteredOutgoingTransactions passed outgoing transactions with filtering already applied
 * */
const OutgoingTransactionsHeaderView = ({ handleShowMaskDelivery, handleSearchInput, setFilterbar, filteredOutgoingTransactions, filterArticles, toggleFilterArticles }) => {
    return(
        <>
            <MainComponentHeaderView title={window.i18n('outbox')} filteredElements={filteredOutgoingTransactions} fileName={window.i18n('outgoing_transactions')} handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} getCsvData={getCsvDataForAllTransactions} showExportButton={false} filterArticles={filterArticles} toggleFilterArticles={toggleFilterArticles}>
                <Button disabled variant="secondary" className="new-transaction-btn form activity-button" onClick={handleShowMaskDelivery}>{window.i18n('addDeliveryOrder')}</Button>
            </MainComponentHeaderView>
        </>
    )
}

/**
 * View for the table of OutgoingTransactions. Lists transaction as main row and the linked articles in a Collapse-Component.
 * @param {any} filteredOutgoingTransactions array with passed outgoing transactions with filtering already applied
 * @param {any} handleSortTransactions handles sorting of transactions
 * @param {boolean} filterable bool to check wheter filter menu is expanded
 * @param {object} DateSelect component for selecting a date
 * @param {object} StateSelect component fpr selecting a value from a given list
 * @param {any} expandRow expands or collapses a row
 * @param {any} getIsExpandedRow returns a bool whether the row to check is expanded or not
 * @param {any} updateTransactionDraft opens a modal for updating a transaction draft, calls a fetch
 * @param {any} removeTransactionDraft removes a transaction draft from the list, calls a fetch 
 * @param {any} handleShowCorrectionModal handles the visibility of a modal for corrections
 * */
const OutgoingTransactionsTableView = ({ filteredOutgoingTransactions, handleSortTransactions, filterable, DateSelect, StateSelect, expandRow, getIsExpandedRow, updateTransactionDraft, removeTransactionDraft, handleShowCorrectionModal }) => {
    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.Sizes.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    return (
        <>
            <div className="tablet-transactions-scroll">
                <Table className="articletype-table table-sm table-sales-striped-immediate ">
                    <thead className="sticky-table-header">
                        <th></th>
                        <th className="mainColumn">{window.i18n('deliveryTarget')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortTransactions(e, 'SourceOrTargetName')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('creationDate')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortTransactions(e, 'CreationDate')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('state')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortTransactions(e, 'State')}>&#8593; &#8595;</a></th>
                        <th className="mainColumn">{window.i18n('remark')}
                                    <a href="" className="sort-link" onClick={(e) => handleSortTransactions(e, 'Remark')}>&#8593; &#8595;</a></th>
                        <th></th>
                    </thead>

                    {filterable ? <thead>
                        <th></th><th></th>
                        <th>{DateSelect}</th>
                        <th>{StateSelect}</th>
                        <th></th>
                        <th></th>
                    </thead> : null}

                    <tbody>
                        {filteredOutgoingTransactions.map((transaction) =>
                            <>
                                <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, transaction.TransactionSysId)} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                    {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                    <td>{transaction.SourceOrTargetName}</td>
                                    <td>{transaction.CreationDate}</td>
                                    <td className={getColourClassStatus(transaction.State)}>{enumvaluetranslations(transaction.State)}</td>
                                    <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltipView(transaction.Remark)}>
                                        <td className="remark-td">{transaction.Remark}</td>
                                    </OverlayTrigger>
                                    <td></td>
                                    {/*if transaction is saved as a draft, add the possibility to edit it*/}
                                    {transaction.IsDraft &&
                                        <td>
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip> {window.i18n('editTransaction')} </Tooltip>}>
                                                <Button className="button-mar" size="sm" variant="secondary" onClick={(e) => updateTransactionDraft(e, transaction)}>&#9998;</Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger className="remove-order-td" placement="bottom" overlay={<Tooltip> {window.i18n('deleteTransaction')} </Tooltip>}>
                                                <a className="remove-order" href="" onClick={(e) => removeTransactionDraft(e, transaction.TransactionSysId)} variant="secondary">&#10060;</a>
                                            </OverlayTrigger>
                                        </td>
                                    }
                                </tr>

                               
                                    //Collapse Component checks via TransactionSysId if the row is expanded.
                                    //Timeout set to 30ms to reduce animation time and stuttering
                                    <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                        <td colSpan="6" className="td-nomargin">
                                        <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                            {[...new Set(transaction.Articles.map(article => article.SizeCat))].map(sizeCat =>
                                                <>
                                                <thead className="sticky-table-header">
                                                    <tr className="salesboutique-childheaderrow">
                                                        <th className="imageColumn"></th>
                                                        <th>{window.i18n('articleNumberDesigner')}</th>
                                                        <th>{window.i18n('articleNumberFaex')}</th>
                                                        <th>{sizeCat}</th>
                                                        <th>{window.i18n('colour')}</th>
                                                        <th className="numberColumn">{window.i18n('salePriceAbb')}</th>
                                                        {getSizeEntries(transaction.Articles.find(x => x.SizeCat === sizeCat).Sizes)}
                                                        <th className="numberColumn">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {transaction.Articles.sort((a, b) => a.Name.localeCompare(b.Name))
                                                    .filter(x => x.SizeCat === sizeCat).map(article =>
                                                        <>
                                                            <tr>
                                                                <td className="imageColumn">{RenderImage(article.Image)}</td>
                                                                <td>{article.ArticleNumberDesigner}</td>
                                                                <td>{article.ArticleIdFaex}</td>
                                                                <td>{article.Name}</td>
                                                                <td>{article.Colour}</td>
                                                                <td className="numberColumn">{parseFloatCurrency(article.SalePrice)}</td>
                                                                {getSizeNumbers(article.Sizes)}
                                                                {getTotal(article.Sizes)}
                                                            </tr>
                                                            {article.CorrectedArticles == true ?
                                                                <tr className={correctionColor((transaction.State === "Inaccurate" ? true : false))}>
                                                                    <td></td>
                                                                    <td>{window.i18n('correction') + ":"}</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    {getCorrectionNumbers(article.Sizes)}
                                                                </tr>
                                                                : null}
                                                        </>
                                                        )}

                                                        <tr className="stockReport-row">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{window.i18n('sum') + ":"} </td>
                                                            <td>{getTotalTotal(transaction.Articles)}</td>
                                                        </tr>

                                                    </tbody>
                                                </>
                                            )}
                                        </div>

                                        {transaction.State === "Inaccurate" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowCorrectionModal(transaction.TransactionSysId)}>{window.i18n('submitCorrection') + "&#10003;"}</Button></td>
                                            </tr>
                                            : null}

                                        <tr>
                                            <td></td>
                                            <td><ExportCSV className="searchBar" disabled={false} csvData={getCsvDataForSingleTransaction(transaction.Articles, [...new Set(transaction.Articles.map(article => article.SizeCat))])} fileName={getCsvFileName(transaction.CreationDate, "_" + window.i18n('deliveryTarget') + "_", transaction.SourceOrTargetName)} isTransaction={true} /></td>
                                        </tr>
                                            
                                        </td>
                                    </Collapse>
                            </>
                        )}
                    </tbody>
                </Table>
            </div>
        </>
    )
}

export { OutgoingTransactionsHeaderView, OutgoingTransactionsTableView }